export default __webpack_public_path__ + "static/media/news3.ad298fa7.mp4";